import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/features-shape.png'


const _hoisted_1 = { class: "features-area ptb-100 bg-gondola2" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "features-single-item position-relative hover-style1" }
const _hoisted_6 = { class: "hover-style2" }
const _hoisted_7 = { class: "text-silver" }
const _hoisted_8 = { class: "count" }
const _hoisted_9 = { class: "col-lg-12 text-center pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "المميزات"),
        _createElementVNode("h2", { class: "text-white" }, "ما الذي يميز Loay IPTV؟")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-xl-4 col-md-6",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": 200 + index * 100
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("i", {
                  class: _normalizeClass([feature.icon, "icon"])
                }, null, 2),
                _createElementVNode("h3", null, [
                  _createVNode(_component_RouterLink, {
                    to: feature.link
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(feature.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("p", _hoisted_7, _toDisplayString(feature.description), 1),
                _createVNode(_component_RouterLink, {
                  to: feature.link,
                  class: "read-more style-two"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(feature.buttonText) + " ", 1),
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ti ti-arrow-right" }, null, -1))
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(index + 1), 1)
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_0,
                class: "features-shape",
                alt: "features-shape"
              }, null, -1))
            ])
          ], 8, _hoisted_4))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_RouterLink, {
            to: "/about-us",
            class: "read-more style-two text-grey-teal"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" استكشف جميع المميزات ", -1),
              _createElementVNode("i", { class: "ti ti-arrow-right" }, null, -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}